import React from "react";

const Card = ({
  as: Component = "div",
  className = "",
  padding = true,
  children,
  ...props
}) => {
  return (
    <Component
      className={`rounded-card border border-hairline bg-paper shadow-card ${
        padding ? "p-5" : ""
      } ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;
